export * from './login/login.component';
export * from './reset-password/reset-password.component';
export * from './forgot-password/forgot-password.component';
export * from './register/register.component';
export * from './signup-successfully/signup-successfully.component';